import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
// import { Breadcrumbs } from '@mui/material';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const ContentDefault = Loadable(lazy(() => import('views/sample-page/table')));

const ListCmp = Loadable(lazy(() => import('views/sample-page/List-component')));
const Config = Loadable(lazy(() => import('views/sample-page/Config')));

const Operation =  Loadable(lazy(() => import('views/sample-page/Operationaldashboard/operationalDashboard')));


const Carousel = Loadable(lazy(() => import('views/sample-page/carousel')));
const Realtimemonitoring = Loadable(lazy(() => import('views/sample-page/Real-time-monitoring')));
const Filtersearch= Loadable(lazy(()=> import('views/sample-page/filtersearch')));
const OffRoadVehicle = Loadable(lazy(() => import('views/sample-page/offRoad')));
const Thresholds = Loadable(lazy(() => import('views/sample-page/Thresholds')));
const Alerts = Loadable(lazy(() => import('views/sample-page/Alerts')));
const Dashboard = Loadable(lazy(() => import('views/sample-page/Maintenance')));
const Breadcrumbs= Loadable(lazy(() => import('views/sample-page/breadcrumb')));
const LiveMeters= Loadable(lazy(() => import('views/sample-page/LiveMeters')));
const Efficiency= Loadable(lazy(() => import('views/sample-page/Efficiency')));
const Speedsensors= Loadable(lazy(() => import('views/sample-page/Speedsensors')));
const Role= Loadable(lazy(() => import('views/sample-page/Role')));
const Manage= Loadable(lazy(() => import('views/sample-page/Manage')));
const Operational= Loadable(lazy(() => import('views/sample-page/Operational')));
const Status= Loadable(lazy(() => import('views/sample-page/Status')));
const Operationaldashboard= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/index.js')));
const Speedometer= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Speedometer')));
const Barometer= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Barometer')));
const AccelDial= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/AccelDail')));
const Battery= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Battery')));
const Dial= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Dial')));
const Indexold= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Indexold')));
const Temp= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Temp')));
const Time= Loadable(lazy(() => import('views/sample-page/Operationaldashboard/Time')));
const Login3= Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page/index.js')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />, 
    children: [
        // {
        //     path: '/',
        //     element: <DashboardDefault />
        // },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/table',
            element: <ContentDefault />
        },
        {
            path: '/List',
            element: <ListCmp />
        },
        {
            path: '/Config',
            element: <Config />
        },
        {
            path: '',
            element: <OffRoadVehicle />
        },
        {
            path: '/Real-time-monitoring',
            element: <Realtimemonitoring />
        },
       
       
        {
            path: '/carousel',
            element: <Carousel />
        },
        {
            path: '/filtersearch',
            element: <Filtersearch/>
        },
        {
            path: '/utils/util-typography',
            element: <UtilsTypography />
        },
        {
            path: '/utils/util-color',
            element: <UtilsColor />
        },
        {
            path: '/utils/util-shadow',
            element: <UtilsShadow />
        },
        {
            path: '/icons/tabler-icons',
            element: <UtilsTablerIcons />
        },
        {
            path: '/icons/material-icons',
            element: <UtilsMaterialIcons />
        },
        {
            path: '/sample-page',
            element: <SamplePage />
        },
        {
            path: '/Thresholds',
            element: <Thresholds />
        },
        {
            path: '/Alerts',
            element: <Alerts />
        },
        {
            path: '/breadcrumb',
            element: <Breadcrumbs />
        },
        {
            path: '/LiveMeters',
            element: <LiveMeters />
        },
        {
            path: '/Efficiency',
            element: <Efficiency />
        },
        {
            path: '/Operationaldashboard',
            element: <Operationaldashboard />
        }, 
        {
            path: '/Speedometer',
            element: <Speedometer />
        }, 
        {
            path: '/Barometer',
            element: <Barometer />
        }, 
        {
            path: '/AccelDial',
            element: <AccelDial />
        },
        {
            path: '/Battery',
            element: <Battery />
        },
        {
            path: '/Dial',
            element: <Dial />
        },
        {
            path: '/Indexold',
            element: <Indexold />
        },
        {
            path: '/Temp',
            element: <Temp />
        },
        {
            path: '/Time',
            element: <Time />
        },
       
        {
            path: '/Role',
            element: <Role />
        },
        {
            path: '/Manage',
            element: <Manage />
        },
        {
            path: '/Speedsensors',
            element: <Speedsensors />
        },
       
        {
            path: '/Login3',
            element: <Login3 />
        },
       
        {
            path: '/Status',
            element: <Status />
        },
        {
            path: '/Operational',
            element: <Operational/>
        },
        {
            path: '/Operation',
            element: <Operation/>
        },
    ]
};

export default MainRoutes;
